import {ISVG} from "../../common/Logo/Logo";

export interface IShape4Props extends Pick<ISVG, "fill"> {}

export const Shape4 = ({ fill }: IShape4Props) => {
    const _fill = fill ?? "white";

    return (
        <svg
            width="638"
            height="120"
            viewBox="0 0 638 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M356.681 -567.489C398.293 -572.262 435.472 -542.362 475.298 -529.392C516.834 -515.865 568.578 -520.324 598.687 -488.674C629.276 -456.518 615.161 -401.494 634.82 -361.703C654.411 -322.05 708.741 -300.243 713.507 -256.272C718.25 -212.507 679.834 -176.008 659.158 -137.144C641.151 -103.295 625.341 -68.0148 598.691 -40.449C573.081 -13.9576 534.792 -4.5033 507.256 19.9811C474.36 49.2324 463.517 108.826 420.468 118.025C377.925 127.115 343.19 80.4224 303.065 63.6133C269.698 49.6353 235.582 40.1106 202.053 26.5262C164.174 11.1796 113.889 11.3021 90.7685 -22.399C67.2993 -56.6092 98.957 -106.93 83.961 -145.611C67.0908 -189.127 2.84649 -209.657 0.109594 -256.248C-2.45748 -299.948 40.6278 -333.957 71.0478 -365.435C98.2896 -393.625 137.163 -405.993 168.093 -430.077C196.881 -452.493 218.668 -481.855 248.156 -503.341C282.411 -528.299 314.574 -562.66 356.681 -567.489Z"
                fill={_fill}
            />
        </svg>
    );
};
